import React, { useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXUserView from "../../../../../Components/BMXUserView/BMXUserView";
import BMXAutocomplete from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import { useTechnicians } from "../../../../../Hooks/useTechniciansHook/useTechnicians";

const SecretFormStepTwo = ({ allTechnicians, ...props }) => {
  const { t } = useTranslation();
  const { values, form } = props;

  const csr = values?.customerServiceRepresentative;
  const prevCsrRef = useRef(values?.customerServiceRepresentative);

  useEffect(() => {
    const currentCsr = values?.customerServiceRepresentative;
    const prevCsr = prevCsrRef.current;

    if (currentCsr?.uuid === prevCsr?.uuid) return;

    let newParticipants = [...(values?.participants || [])];

    if (prevCsr) {
      newParticipants = newParticipants.filter((p) => p.uuid !== prevCsr.uuid);
    }

    if (currentCsr) {
      const isAlreadyAdded = newParticipants.some(
        (p) => p.uuid === currentCsr.uuid,
      );
      if (!isAlreadyAdded) {
        newParticipants.push(currentCsr);
      }
    }

    form.change("participants", newParticipants);
    prevCsrRef.current = currentCsr;
  }, [values?.customerServiceRepresentative, form]);

  return (
    <div className="SecretFormStepTwo" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:secret.participants")} />
      <Row>
        <Col xs={6}>
          <Field
            component={BMXAutocomplete}
            options={allTechnicians}
            data-cy="participants"
            currentValues={{ participants: values?.participants || [] }}
            label={t("global:secret.participants")}
            limitTags={1}
            multiple
            getOptionDisabled={(option) => option.uuid === csr?.uuid}
            isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
            renderTags={(tagValue, getTagProps) => {
              return tagValue.map((option, index) => {
                const isCSR = option.uuid === csr?.uuid;
                return (
                  <BMXUserView
                    {...getTagProps({ index })}
                    key={option.uuid}
                    user={option}
                    color="primary"
                    disabled={isCSR}
                    onDelete={
                      isCSR ? undefined : getTagProps({ index }).onDelete
                    }
                  />
                );
              });
            }}
            name="participants"
            renderOption={(props, option) => (
              <li key={option.uuid} {...props}>
                <BMXUserView color="primary" user={option}></BMXUserView>
              </li>
            )}
            // Poprawione formatowanie labela
            getOptionLabel={(option) =>
              option ? `${option.firstName} ${option.lastName}` : ""
            }
          />
        </Col>

        <Col md={6}>
          <div className="summary">
            <span className="pb-2 d-block">
              {t("global:secret.participants")}
            </span>
            <div
              className="area"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              {Array.isArray(values?.participants) &&
                values?.participants?.map((el) => (
                  <BMXUserView
                    key={el.uuid}
                    className="mt-2"
                    line={"line"}
                    color="primary"
                    user={el}
                  />
                ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SecretFormStepTwo;
